import React, { useState, useEffect, useContext, useCallback } from "react";
import { LiabilityReport } from "./LiabilityDashboardComponents/LiabilityReport";
import { LiabilityInfo } from "./LiabilityDashboardComponents/LiabilityInfo";
import { CreditTable } from "./LiabilityDashboardComponents/CreditTable";
import { LiabilityTable } from "./LiabilityDashboardComponents/LiabilityTable";
import { useHistory } from "react-router-dom";
import "./LiabilityDashboard.css";
import FETCH from "../../utils/fetch";
import {
  setRefreshTime,
  setRefreshTimeAsset,
} from "../../redux/slices/itemsSlice";
import { useDispatch } from "react-redux";
import DEATH_API from "../../apis/death.api";
import swal from "sweetalert";
import { MODULE_API } from "../../apis";
import moment from "moment";
import { FutureLoan } from "./LiabilityDashboardComponents/FutureLoan";
import { GlobalLoaderContext } from "../../utils/GlobalLoaderContext";
import ModalVideo from "../ModuleVideos/ModalVideo";
import { LoadingOutlined } from "@ant-design/icons";
export const LiabilityDashboard = () => {
  const history = useHistory();
  const { runWithLoader } = useContext(GlobalLoaderContext);
  const reportRef = React.useRef(null);
  const [sharedState, setSharedState] = useState(false);
  const [downloadLoading, setDownloadLoading] = useState(false);
  const dispatch = useDispatch();

  const handleDownloadLoading = useCallback((loading) => {
    setDownloadLoading(loading);
  }, []);
  // Function to update the shared state
  const updateSharedState = (newState) => {
    setSharedState(newState);
  };
  const [loadingCounter, setLoadingCounter] = useState(0);
  const [refreshingModule, setRefreshingModule] = useState(false);
  const loading = loadingCounter > 0;
  // Pagination state
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [cachedData, setCachedData] = useState({});
  // state for creditTable
  const [liabilitiesCredit, setLiabilitesCredit] = useState([]);
  const [creditRows, setCreditRows] = useState([]);
  const [futureLoan, setFutureLoan] = useState([]);
  const [liabilityCreditHigherValue, setLiabilityCreditHigherValue] = useState(
    []
  );

  // state for Liablityinfo
  const [total, setTotal] = useState(null);

  const [totalNoCredit, setTotalNoCredit] = useState(null);
  // Pagination state
  const [currentPageCredit, setCurrentCreditPage] = useState(1);
  const [totalCreditPages, setTotalCreditPages] = useState(1);
  const [cachedDataCredit, setCachedDataCredit] = useState({});

  const [totalAmount, setTotalAmount] = useState(0);
  const [totalMonthly, setTotalMonthly] = useState(0);
  const [totalAmountAll, setTotalAmountAll] = useState(0);
  const [creditCount, setCreditCount] = useState(0);
  const [totalCountAndBalance, setTotalCountAndBalance] = useState(null);
  const [totalCreditLimit, setTotalCreditLimit] = useState(0);
  const [averageInterestRate, setAverageInterestRate] = useState(null);
  const [highestARP, setHighestARP] = useState(0);
  const [highestLoan, setHighestLoan] = useState(0);
  const [highestMonthly, setHighestMonthly] = useState(0);
  const [totalMonthDiff, setTotalMonthDiff] = useState(0);
  const [newLiabilitySum, setNewLiabilitySum] = useState();
  const [newCreditSum, setNewCreditSum] = useState();
  const [allCreditRowsForChart, setAllCreditRowsForChart] = useState([]);
  const [allLiabilitiesForChart, setAllLiabilitiesForChart] = useState([]);
  const [loadingChartData, setLoadingChartData] = useState(false);
  const [loadingLiabilityChartData, setLoadingLiabilityChartData] = useState(false);

  const beginLoading = useCallback(() => {
    setLoadingCounter((prev) => prev + 1);
  }, []);

  const endLoading = useCallback(() => {
    setLoadingCounter((prev) => {
      const next = Math.max(prev - 1, 0);
      return next;
    });
  }, []);

  const handleDownloadReport = useCallback(() => {
    if (downloadLoading || loading || loadingLiabilityChartData) return;
    if (reportRef.current && typeof reportRef.current.downloadPDF === "function") {
      reportRef.current.downloadPDF();
    }
  }, [downloadLoading, loading, loadingLiabilityChartData]);
  const moduleStateMapping = {
    Student: "student",
    Auto: "auto",
    "Real Estates": "realEstate",
  };
  console.log("===>totalAmountAll===>", JSON.stringify(totalAmountAll));

  // states for Liablity Report
  const [totalLoan, setTotalLoan] = useState(0);
  const [totalBalance, setTotalBalance] = useState(0);
  const [totalBalanceUpdated, setTotalBalanceUpdated] = useState(0);
  const [syncPayload, setSyncPayload] = useState([]);
  const [clientBanks, setClientBanks] = useState(null);
  const [liabilitiesAll, setLiabilitesAll] = useState([]);
  const getAssetsList = async (page, options = {}) => {
    const { forceRefresh = false } = options;
    console.log("here in cached data", cachedData, page);
    if (!forceRefresh && cachedData && cachedData[page]) {
      // Use cached data
      updateStateWithData(cachedData[page]);
      return;
    }
    try {
      beginLoading();
      const userRole =
        localStorage.getItem("role") != "undefined" &&
        JSON.parse(localStorage.getItem("role"));
      const ID = localStorage.getItem("accessId");
      let datares = await FETCH.post({
        url: "client-module-service/client-module/list",
        id:
          userRole === "Financial Advisor Client"
            ? `?module=Liability&page=${page}&limit=10&clientId=${ID}`
            : `?module=Liability&page=${page}&limit=10`,
        body: {},
      });
      endLoading();

      if (datares && datares.records) {
        // Cache the data for the current page
        setCachedData((prevState) => ({
          ...prevState,
          [page]: datares,
        }));
        updateStateWithData(datares);
      }
    } catch (error) {
      console.log(error);
      endLoading();
    }
  };
  const getCreditList = async (page, options = {}) => {
    const { forceRefresh = false } = options;
    console.log("here in cached data", cachedData, page);
    if (!forceRefresh && cachedDataCredit && cachedDataCredit[page]) {
      // Use cached data
      updateStateWithCreditData(cachedDataCredit[page]);
      return;
    }
    try {
      beginLoading();
      const userRole =
        localStorage.getItem("role") != "undefined" &&
        JSON.parse(localStorage.getItem("role"));
      const ID = localStorage.getItem("accessId");
      let datares = await FETCH.post({
        url: "client-module-service/client-module/list",
        id:
          userRole === "Financial Advisor Client"
            ? `?module=Credit&page=${page}&limit=10&clientId=${ID}`
            : `?module=Credit&page=${page}&limit=10`,
        body: {},
      });
      endLoading();

      if (datares && datares.records) {
        // Cache the data for the current page
        setCachedDataCredit((prevState) => ({
          ...prevState,
          [page]: datares,
        }));
        updateStateWithCreditData(datares);
      }
    } catch (error) {
      console.log(error);
      endLoading();
    }
  };

  const fetchAllCreditForChart = async () => {
    try {
      setLoadingChartData(true);
      const userRole =
        localStorage.getItem("role") != "undefined" &&
        JSON.parse(localStorage.getItem("role"));
      const ID = localStorage.getItem("accessId");

      let allRecords = [];
      let page = 1;
      let totalPages = 1;

      do {
        let datares = await FETCH.post({
          url: "client-module-service/client-module/list",
          id:
            userRole === "Financial Advisor Client"
              ? `?module=Credit&page=${page}&limit=10&clientId=${ID}`
              : `?module=Credit&page=${page}&limit=10`,
          body: {},
        });

        if (datares && datares.records) {
          allRecords = [...allRecords, ...datares.records];
          if (datares.pagination) {
            totalPages = Math.ceil(datares.pagination.total / datares.pagination.limit);
          }
        } else {
          break;
        }
        page++;
      } while (page <= totalPages);

      setAllCreditRowsForChart(allRecords);
      // Proactively calculate and fix totals from full records if summary API lacks them
      const totalCreditBalance = allRecords.reduce((sum, item) => sum + (parseFloat(item["Credit Balance"]) || 0), 0);
      const totalCreditLimit = allRecords.reduce((sum, item) => sum + (parseFloat(item["Credit Limit"]) || 0), 0);

      // if (totalCreditBalance > 0) setTotalBalance(totalCreditBalance);
      // if (totalCreditLimit > 0) setTotalCreditLimit(totalCreditLimit);
      setLoadingChartData(false);
    } catch (error) {
      console.log("Error fetching all credit data for chart:", error);
      setLoadingChartData(false);
    }
  };

  const fetchAllLiabilitiesForChart = async () => {
    try {
      setLoadingLiabilityChartData(true);
      const userRole =
        localStorage.getItem("role") != "undefined" &&
        JSON.parse(localStorage.getItem("role"));
      const ID = localStorage.getItem("accessId");

      let allRecords = [];
      let page = 1;
      let totalPages = 1;

      do {
        let datares = await FETCH.post({
          url: "client-module-service/client-module/list",
          id:
            userRole === "Financial Advisor Client"
              ? `?module=Liability&page=${page}&limit=10&clientId=${ID}`
              : `?module=Liability&page=${page}&limit=10`,
          body: {},
        });

        if (datares && datares.records) {
          const liabilities = datares.records.filter(
            (record) => record.subType === "Liability"
          );
          allRecords = [...allRecords, ...liabilities];
          if (datares.pagination) {
            totalPages = Math.ceil(
              datares.pagination.total / datares.pagination.limit
            );
          }
        } else {
          break;
        }
        page++;
      } while (page <= totalPages);

      setAllLiabilitiesForChart(allRecords);
      // Proactively calculate and fix totals from full records if summary API lacks them
      const totalLoanSum = allRecords.reduce((sum, item) => sum + (parseFloat(item["Loan Balance"] || item["Initial Loan Amount"]) || 0), 0);
      if (totalLoanSum > 0) setTotalLoan(totalLoanSum);
      setLoadingLiabilityChartData(false);
    } catch (error) {
      console.log("Error fetching all liability data for chart:", error);
      setLoadingLiabilityChartData(false);
    }
  };
  const getFutureLoan = async () => {
    try {
      beginLoading();
      let datares = await MODULE_API.fetchFutureLoans(1);
      console.log("datares fultytt", datares);
      if (datares && datares.records) {
        setFutureLoan(datares.records);
      }
      endLoading();
    } catch (error) {
      console.log(error);
      endLoading();
    }
  };
  const getBankDetails = async () => {
    try {
      beginLoading();
      let data = await DEATH_API.getBankDetails();
      setSyncPayload([]);
      let obj = [];
      let bankData = {};
      if (data && data.data) {
        const newArray = data.data.map((account) => {
          return {
            accountId: account.accountId,
            accountName: `${account.accountName}`,
            bankName: account.bankName,
            subType: account.subType,
            accountNumber: account.mask,
            accountTitle: `${account.accountName} ${account.mask}`,
            balance: account.balance,
          };
        });
        setClientBanks([
          ...newArray,
          {
            accountId: 1234,
            accountName: "cash",
            bankName: "devbank",
            subType: "debsubtype",
            accountNumber: 1122,
            accountTitle: "Cash",
            balance: 1111,
          },
        ]);

        data.data.forEach((item) => {
          if (!bankData[item.bankName]) {
            bankData[item.bankName] = [];
          }
          bankData[item.bankName].push({
            ...item,
            bankName: item.bankName,
            mask: item.mask,
          });
        });
        data.data.map((item, idx) => {
          obj.push({
            bankName: item.bankName,
            mask: item.mask,
            accessToken: item.accessToken,
          });
        });
      }
      setSyncPayload((prevState) => [...prevState, ...obj]);
      endLoading();
    } catch (error) {
      console.log(error);
      endLoading();
    }
  };
  const updateStateWithData = (datares) => {
    // Reset states
    setLiabilitesCredit([]);
    setTotalBalanceUpdated(0);
    setTotalCountAndBalance(null);
    setAverageInterestRate(null);
    setLiabilitesAll([]);
    setTotalAmountAll(0);
    setTotalMonthly(0);
    setTotalAmount(0);
    setTotal(0);

    let highestInitialLoanAmount = 0;
    let highestInterestRate = 0;
    let highestMonthlyPayment = 0;
    let totalMonthsDifference = 0;
    let totalCards = 0;
    let totalMonthsDifferenceLiability = 0;
    let totalCardsLiability = 0;

    if (datares && datares.records) {
      const liabilities = datares.records.filter(
        (record) => record.subType === "Liability"
      );
      setLiabilitesAll(liabilities);

      liabilities.forEach((item) => {
        const currentDate = new Date();
        if (
          item["Maturity Date"] &&
          new Date(item["Maturity Date"]) > currentDate
        ) {
          const creditCardOpenDate = item["Start Date"]
            ? new Date(item["Start Date"])
            : new Date();
          const TodaysDate = new Date();
          const diffYears =
            TodaysDate.getFullYear() - creditCardOpenDate.getFullYear();
          const diffMonths =
            diffYears * 12 +
            (TodaysDate.getMonth() - creditCardOpenDate.getMonth());

          totalCardsLiability += 1;
          totalMonthsDifferenceLiability += diffMonths;
        }
        setLiabilitesCredit((prevState) => [...prevState, item]);
        // setTotalLoan(
        //   (prevState) => prevState + (+item["Initial Loan Amount"] || 0)
        // );

        const moduleKey = moduleStateMapping[item.module] || "other";

        if (
          ((item["Loan Balance"] && item["Loan Balance"]) ||
            item["Initial Loan Amount"]) > 0 &&
          item.subType === "Liability"
        ) {
          setTotalAmountAll((prevState) => ({
            ...prevState,
            [moduleKey]:
              (prevState[moduleKey] || 0) +
              parseFloat(
                item["Loan Balance"] || +item["Initial Loan Amount"] || 0
              ),
            other:
              moduleKey === "other"
                ? (prevState.other || 0) +
                parseFloat(
                  item["Loan Balance"] || +item["Initial Loan Amount"] || 0
                )
                : prevState.other || 0,
          }));
        }

        if (item["Monthly Payment"] && item["Monthly Payment"] > 0) {
          setTotalMonthly(
            (prevState) => prevState + (+item["Monthly Payment"] || 0)
          );
        }

        if (
          (item["Credit Balance"] && item["Credit Balance"] > 0) ||
          ((item["Loan Balance"] && +item["Loan Balance"]) ||
            (item["Initial Loan Amount"] && item["Initial Loan Amount"])) > 0
        ) {
          setTotalAmount(
            (prevState) =>
              prevState +
              (item["Credit Balance"] || 0) +
              (+item["Loan Balance"] || item["Initial Loan Amount"] || 0)
          );
        }

        if (
          item["Initial Loan Amount"] &&
          item["Initial Loan Amount"] > highestInitialLoanAmount
        ) {
          highestInitialLoanAmount =
            item["Loan Balance"] || item["Initial Loan Amount"];
        }
        if (
          item["Interest Rate"] &&
          item["Interest Rate"] > highestInterestRate
        ) {
          highestInterestRate = item["Interest Rate"];
        }
        if (
          item["Interest Rate (or APR%)"] &&
          item["Interest Rate (or APR%)"] > highestInterestRate
        ) {
          highestInterestRate = item["Interest Rate (or APR%)"];
        }
        if (
          item["Monthly Payment"] &&
          +item["Monthly Payment"] > highestMonthlyPayment
        ) {
          highestMonthlyPayment = +item["Monthly Payment"];
        }
      });
    }

    if (datares && datares.pagination) {
      setTotal(datares.pagination.total);
      setTotalPages(
        Math.ceil(datares.pagination.total / datares.pagination.limit)
      );
    }

    const cardsDifference = totalCards > 0 ? totalMonthsDifference / totalCards : 0;
    const liabilityDifference =
      totalCardsLiability > 0 ? totalMonthsDifferenceLiability / totalCardsLiability : 0;

    let averageAge = 0;
    if (totalCards > 0 && totalCardsLiability > 0) {
      averageAge = (cardsDifference + liabilityDifference) / 2;
    } else if (totalCards > 0 || totalCardsLiability > 0) {
      averageAge = cardsDifference + liabilityDifference;
    }

    setTotalMonthDiff(averageAge.toFixed(2));
    setHighestARP(highestInterestRate);
    setHighestLoan(highestInitialLoanAmount);
    setHighestMonthly(highestMonthlyPayment);
  };
  const updateStateWithCreditData = (datares) => {
    setCreditRows([]);
    if (datares && datares.records) {
      setCreditRows(datares.records);
      const totalMonthlyPayment = datares.records.reduce((sum, card) => {
        const payment = +card["Monthly Payment"] || 0;
        return sum + payment;
      }, 0);
      setTotalMonthly((prev) => prev + totalMonthlyPayment);
    }

    if (datares && datares.pagination) {
      setTotalNoCredit(datares.pagination.total);
      setTotalCreditPages(
        Math.ceil(datares.pagination.total / datares.pagination.limit)
      );
    }
  };

  // with out unique modules
  const nicknames =
    creditRows && creditRows.map((card) => card["Nickname of Credit"] || null);

  useEffect(() => {
    getAssetsList(currentPage);
    if (!clientBanks) {
      getBankDetails();
    }
  }, [currentPage]);

  useEffect(() => {
    getCreditList(currentPageCredit);
  }, [currentPageCredit]);

  useEffect(() => {
    setCachedData({});
    setCachedDataCredit({});
    getAssetsList(currentPage, { forceRefresh: true });
    getCreditList(currentPageCredit, { forceRefresh: true });
    fetchAllCreditForChart();
    fetchAllLiabilitiesForChart();
    getAll();
  }, [sharedState]);
  const refreshModule = async () => {
    try {
      setRefreshingModule(true);
      beginLoading();
      setCachedData({});
      setCachedDataCredit({});
      await Promise.all([
        getAssetsList(1),
        getCreditList(1),
        fetchAllLiabilitiesForChart()
      ]);
      endLoading();
    } catch (error) {
      endLoading();
      console.error("Error fetching user data:", error);
    } finally {
      setRefreshingModule(false);
    }
  };

  const updatePayment = () => {
    history.push("/payment");
  };

  const getDebt = async (startDate, endDate) => {
    try {
      beginLoading();
      setTotalBalanceUpdated(0);
      let data = await MODULE_API.getDebt(startDate, endDate);

      if (data && data.data) {
        setTotalBalanceUpdated(data.data);
      }
      endLoading();
    } catch (error) {
      endLoading();
      console.log(error);
    }
  };
  const getLiabilitySum = async () => {
    try {
      beginLoading();
      setTotalLoan(0);
      let data = await MODULE_API.fetchLiabilitySum("Liability");
      if (data && data.sum) {
        setTotalLoan(data.sum);
      }
      endLoading();
    } catch (error) {
      endLoading();
      console.log(error);
    }
  };
  const getCreditSum = async () => {
    try {
      beginLoading();
      setTotalBalance(0);
      setCreditCount(0);
      setTotalCreditLimit(0);
      let data = await MODULE_API.fetchLiabilitySum("Credit");
      if (data && data.sum) {
        setTotalBalance(data.sum);
        setCreditCount(data.moduleCount);
        setTotalCreditLimit(data.creditLimitSum);

      }
      endLoading();
    } catch (error) {
      endLoading();
      console.log(error);
    }
  };
  // const getLiabilityCreditSum = async () => {
  //   try {
  //     beginLoading();
  //     // setTotalBalance(0);
  //     let data = await MODULE_API.fetchLiabilityCreditSum("Credit");
  //     console.log('credit-----------',data)
  //     let data1 = await MODULE_API.fetchLiabilityCreditSum("Liability");
  //     console.log('liability-----------',data1)
  //     if (data && data.sum) {
  //       // setTotalBalance(data.sum);
  //     }
  //     endLoading();
  //   } catch (error) {
  //     endLoading();
  //     console.log(error);
  //   }
  // };
  const getLiabilityCreditHigherValue = async () => {
    try {
      beginLoading();
      // setTotalBalance(0);
      let data = await MODULE_API.fetchLiabilityCreditHigherValue();
      if (data && data.result && data.result.length > 0) {
        // setTotalBalance(data.sum);
        const highestLoanBalance = data.amotizaionResult && data.amotizaionResult[0] && data.amotizaionResult[0]["max_balance"] || 0;
        setLiabilityCreditHigherValue({ ...data.result[0], highestLoanBalance: highestLoanBalance });
      }
      endLoading();
    } catch (error) {
      endLoading();
      console.log(error);
    }
  };
  const getLiabilityCreditSum = async () => {
    try {
      beginLoading();

      const [creditRes, liabilityRes] = await Promise.all([
        MODULE_API.fetchLiabilityCreditSum("Credit"),
        MODULE_API.fetchLiabilityCreditSum("Liability"),
      ]);

      setNewCreditSum(creditRes);
      if (creditRes != null) {
      }

      setNewLiabilitySum(liabilityRes);
      if (liabilityRes != null) {
      }
    } catch (error) {
      console.log(error);
    } finally {
      endLoading();
    }
  };
  const callFilter = async (startDate, endDate) => {
    await getDebt(startDate, endDate);
  };
  const getAll = async () => {
    await runWithLoader(
      async () => {
        await Promise.all([
          getFutureLoan(),
          getLiabilitySum(),
          getCreditSum(),
          getLiabilityCreditSum(),
          getLiabilityCreditHigherValue(),
        ]);
      },
      () => {
        // 👇 This runs only if global loader actually shows after 4s
        setLoadingCounter(0);
      }
    );
  };

  useEffect(() => {
    const date = moment();
    const startDate = date.startOf("month").format("YYYY-MM-DD");
    const endDate = date.endOf("month").format("YYYY-MM-DD");
    // callFilter(startDate, endDate);
    // getAll();
  }, []);

  return (
    <div className="liabilityMain">
      <ModalVideo module="Liabilities & Credit" autoOpen={true} />
      <div className="liabilitycreate">
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            gap: "1rem",
          }}
        >
          <div style={{ display: "flex", gap: "1rem" }}>
            <button
              className="addbuttonLiablity"
              onClick={() => {
                history.push("/debt-payoff");
              }}
            >
              Go to Debt Payoff
            </button>

            <button
              className="addbuttonLiablity"
              onClick={() => {
                history.push("/liabilities_credit_new");
              }}
            >
              {" "}
              + Add Liability
            </button>
          </div>

          <button
            className={`addbuttonassets addbuttonassets--secondary assets-download-button${
              downloadLoading || loading || loadingLiabilityChartData
                ? " addbuttonassets--loading"
                : ""
            }`}
            style={{ margin: 0, padding: "0.5rem" }}
            disabled={downloadLoading || loading || loadingLiabilityChartData}
            onClick={handleDownloadReport}
            aria-busy={downloadLoading || loading || loadingLiabilityChartData}
            aria-live="polite"
          >
            <span className="assets-download-icon-shell" aria-hidden="true">
              {downloadLoading || loading || loadingLiabilityChartData ? (
                <LoadingOutlined
                  className="assets-download-icon"
                  style={{ color: "#ffffff" }}
                  spin
                />
              ) : (
                <svg
                  className="assets-download-icon assets-download-svg-icon"
                  viewBox="0 0 24 24"
                  fill="none"
                  aria-hidden="true"
                >
                  <path
                    d="M12 4.5V14.5"
                    stroke="currentColor"
                    strokeWidth="2.25"
                    strokeLinecap="round"
                  />
                  <path
                    d="M8.5 11.5L12 15L15.5 11.5"
                    stroke="currentColor"
                    strokeWidth="2.25"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <path
                    d="M6 18.5H18"
                    stroke="currentColor"
                    strokeWidth="2.25"
                    strokeLinecap="round"
                  />
                </svg>
              )}
            </span>
            {downloadLoading
              ? "Downloading..."
              : loading || loadingLiabilityChartData
                ? "Preparing chart..."
                : "Download Report"}
          </button>
        </div>
      </div>
      <div className="liabilityMainReport">
        <LiabilityReport
          ref={reportRef}
          onDownloadLoading={handleDownloadLoading}
          sharedState={sharedState}
          updateSharedState={updateSharedState}
          totalLoan={totalLoan}
          totalBalance={totalBalance}
          liabilitiesCredit={liabilitiesAll && liabilitiesAll}
          creditRows={creditRows && creditRows}
          allLiabilitiesForChart={allLiabilitiesForChart}
          allCreditRowsForChart={allCreditRowsForChart}
          futureLoans={futureLoan}
          loading={loading}
          loadingLiabilityChartData={loadingLiabilityChartData}
          totalBalanceUpdated={totalBalanceUpdated}
          // Added props for summary in PDF
          total={total}
          totalNoCredit={totalNoCredit}
          totalMonthly={totalMonthly}
          totalCreditLimit={totalCreditLimit}
          newLiabilitySum={newLiabilitySum}
          liabilityCreditHigherValue={liabilityCreditHigherValue}
          totalMonthDiff={totalMonthDiff}
        />
      </div>
      <div className="liablityInfoMain">
        <LiabilityInfo
          sharedState={sharedState}
          updateSharedState={updateSharedState}
          total={total}
          totalAmount={totalAmount}
          totalMonthly={totalMonthly}
          totalAmountAll={totalAmountAll}
          creditCount={creditCount}
          totalCountAndBalance={totalCountAndBalance}
          totalCreditLimit={totalCreditLimit}
          averageInterestRate={averageInterestRate}
          highestARP={highestARP}
          highestLoan={highestLoan}
          highestMonthly={highestMonthly}
          totalMonthDiff={totalMonthDiff}
          loading={loading}
          totalLoan={totalLoan}
          totalBalance={totalBalance}
          newCreditSum={newCreditSum}
          newLiabilitySum={newLiabilitySum}
          creditRows={creditRows && creditRows}
          totalNoCredit={totalNoCredit}
          setLiabilityCreditHigherValue={setLiabilityCreditHigherValue}
          liabilityCreditHigherValue={liabilityCreditHigherValue}
        />
      </div>
      <div className="creditMainTag">
        <CreditTable
          sharedState={sharedState}
          updateSharedState={updateSharedState}
          creditRows={creditRows && creditRows}
          liabilitiesCredit={liabilitiesCredit && liabilitiesCredit}
          loading={loading}
          loadingChartData={loadingChartData}
          allCreditRowsForChart={allCreditRowsForChart}
          totalPages={totalPages}
          currentPage={currentPage}
          setCurrentPage={setCurrentPage}
          refreshModule={refreshModule}
          refreshingModule={refreshingModule}
        />
      </div>
      <div className="liabilityTableCard">
        <LiabilityTable
          sharedState={sharedState}
          updateSharedState={updateSharedState}
          creditRows={creditRows && creditRows}
          loading={loading}
          totalPages={totalCreditPages}
          currentPage={currentPageCredit}
          setCurrentPage={setCurrentCreditPage}
          refreshModule={refreshModule}
          refreshingModule={refreshingModule}
        />
      </div>
      <div className="liabilityTableCard">
        <FutureLoan
          sharedState={sharedState}
          updateSharedState={updateSharedState}
          futureLoans={futureLoan && futureLoan}
          loading={loading}
        />
      </div>
    </div>
  );
};
